// extracted by mini-css-extract-plugin
module.exports = {"container":"CompanyAvatarLabelGroupLink_container__1Ditn","sending":"CompanyAvatarLabelGroupLink_sending__3-vX-"};